export default __webpack_public_path__ + "static/Vanilla Rum Jacquard-0a0efe52b7ef1db5cfbed989248ca4ce.webp";